import { render, staticRenderFns } from "./GettingStarted.vue?vue&type=template&id=d170abb2&scoped=true"
import script from "./GettingStarted.vue?vue&type=script&lang=js"
export * from "./GettingStarted.vue?vue&type=script&lang=js"
import style0 from "./GettingStarted.vue?vue&type=style&index=0&id=d170abb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d170abb2",
  null
  
)

export default component.exports